export default function Login() {
    let Oauth_Api_Login = "https://oauth.cmu.ac.th/v1/Authorize.aspx"
    let Client_ID = "qhJJ406qCTSWSg5rQyeAj3e7WcQFMqmwA0MSUUp8"      
    var Redirect_URI
    if (window.location.host === 'localhost:3000') {
      Redirect_URI = 'http://' + window.location.host + '/callback';
    } else  {
      Redirect_URI = 'https://' + window.location.host + '/callback';
    }        
    window.location.replace(
      `${Oauth_Api_Login}?response_type=code&client_id=${Client_ID}&redirect_uri=${Redirect_URI}&cope=cmuitaccount.basicinfo`
    )
}